import React from 'react';
import { ReactComponent as CoilPattern } from '../assets/espaces-culturel/cccoil.svg';

const ProjectsCoilBackground = () => (
  <div className="projects-coil-bg" aria-hidden="true">
    <div className="projects-coil-bg__stage">
      <CoilPattern className="projects-coil-bg__svg" focusable="false" />
    </div>
  </div>
);

export default ProjectsCoilBackground;
